import React from "react";
import { Button } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";

/**
 * Botão Adicionar padronizado — usado no GridPadrao e em formulários.
 *
 * @param {Function} onClick        - Handler ao clicar
 * @param {boolean}  [disabled]     - Desabilita o botão (ex.: já existe registro ativo)
 * @param {string}   [title]        - Tooltip exibido ao passar o mouse
 * @param {string}   [label]        - Texto do botão (padrão: "Adicionar")
 * @param {string}   [variant]      - Variante Bootstrap (padrão: "primary")
 * @param {string}   [size]         - Tamanho Bootstrap (padrão: "sm")
 * @param {string}   [className]    - Classes CSS adicionais
 * @param {number}   [iconSize]     - Tamanho do ícone em px (padrão: 13)
 */
function Adicionar({
  onClick,
  disabled = false,
  title,
  label = "Adicionar",
  variant = "primary",
  size = "sm",
  className = "d-flex align-items-center",
  iconSize = 13,
  ...rest
}) {
  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={onClick}
      disabled={disabled}
      title={title}
      {...rest}
    >
      <FaPlus size={iconSize} className="me-1" />
      <span>{label}</span>
    </Button>
  );
}

export default Adicionar;
